export class LinkTarget {
  public kind: 'internal' | 'external' = 'external';
  public routerLink?: string | undefined;
  public queryParams?: Record<string, string> | undefined;
  public fragment?: string | undefined;
  public href?: string | undefined;

  constructor(data?: Partial<LinkTarget>) {
    if (data == undefined) { return; }
    if (data.kind != undefined) { this.kind = data.kind; }
    if (data.queryParams != undefined) { this.queryParams = data.queryParams; }
    if (data.fragment != undefined) { this.fragment = data.fragment; }
    if (data.href != undefined) { this.href = data.href; }
  }
}
